<template>
  <div class="main_control">
    <a-modal :visible="visible" title="打印选择" @ok="print" @cancel="visible = false" width='50%' height='1000px'>
      <!-- :width="imgStyle.width + 48 + 'px'" -->
      <img :src="src" :style="imgStyle" width="100%" height="100%" />
    </a-modal>
  </div>
</template>
<script>
import DragBox from 'ol/interaction/DragBox'
import Select from 'ol/interaction/Select'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
import Circle from 'ol/style/Circle'
import printJS from 'print-js'
import { Polygon } from 'ol/geom'
export default {
  name: 'DragBox',
  data () {
    return {
      src: '',
      canDrag: false,
      imgStyle: {
        height: '',
        width: ''
      },
      visible: false
    }
  },
  watch: {
    visible: {
      handler (newVal) {
        if (newVal) {
          this.vectorSource.clear()
          this.canDrag = false
        }
      },
      deep: true
    }
  },
  mounted () {
    this.vectorSource = new VectorSource()
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      style: new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(0,255,255, 0.0)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#2F4F4F',
          width: 3
        })
      })
    })
  },
  methods: {
    // print(){
    //   window.print()
    // },
    clearMap () {
      this.vectorSource.clear()
      var map = this.$parent.getBigMap()
      if (this.dragBox) {
        map.removeInteraction(this.dragBox)
      }
      // console.log(this.dragBox)
    },
    selectBoxPrint () {
      var map = this.$parent.getBigMap()
      map.removeLayer(this.vectorLayer)
      this.canDrag = !this.canDrag
      if (this.canDrag) {
        var boxSelect = new Select()
        var that = this
        var selectedFeatures = boxSelect.getFeatures()
        this.dragBox = new DragBox({
          // condition : ol.events.condition.always  默认是always
        })
        map.addInteraction(that.dragBox)
        map.addLayer(this.vectorLayer)
        that.dragBox.on('boxend', function () {
          var extent = that.dragBox.getGeometry().getExtent()
          console.log('boxend', extent)
          that.vectorSource.addFeature(new Feature({
            geometry: that.dragBox.getGeometry()
          }))
          that.splitCanvas(map, extent)
          map.removeInteraction(that.dragBox)
        })
        that.dragBox.on('boxstart', function () {
          selectedFeatures.clear()
          that.vectorSource.clear()
        })
      } else {
        this.clearMap()
      }
    },
    splitCanvas (map, extent) {
      if (extent.length === 4) {
        var leftTopPoint = [extent[0], extent[3]]
        var rightBottomPoint = [extent[2], extent[1]]
      }
      const that = this
      var pxLeftTop = map.getPixelFromCoordinate(leftTopPoint)
      var pxRightBottom = map.getPixelFromCoordinate(rightBottomPoint)
      map.once('rendercomplete', function () {
        // let that = this
        const mapCanvas = document.createElement('canvas')
        const size = map.getSize()
        mapCanvas.width = size[0]
        mapCanvas.height = size[1]
        console.log('mapCanvas', mapCanvas)
        const mapContext = mapCanvas.getContext('2d')
        Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity)
            const transform = canvas.style.transform
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number)
            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix)
            mapContext.drawImage(canvas, 0, 0)
          }
        })
        const mapCanvas2 = document.createElement('canvas')
        const width = pxRightBottom[0] - pxLeftTop[0]
        const height = pxRightBottom[1] - pxLeftTop[1]
        mapCanvas2.width = width
        mapCanvas2.height = height
        console.log((width / document.body.clientWidth) * 100 + '%')
        that.imgStyle.width = width
        that.imgStyle.height = height
        // that.imgStyle.width='595px';
        // that.imgStyle.height='876px';
        const mapContext2 = mapCanvas2.getContext('2d')
        mapContext2.drawImage(
          mapCanvas,
          pxLeftTop[0],
          pxLeftTop[1],
          pxRightBottom[0] - pxLeftTop[0],
          pxRightBottom[1] - pxLeftTop[1],
          0,
          0,
          pxRightBottom[0] - pxLeftTop[0],
          pxRightBottom[1] - pxLeftTop[1]
        )
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(mapCanvas2.msToBlob(), '导出图片.png')
        } else {
          // that.src=url;
          //   that.visible=true;
          console.log(pxLeftTop, pxRightBottom)
          mapCanvas2.toBlob(function (blob) {
            console.log(blob)
            const url = (window.URL || window.webkitURL).createObjectURL(blob)
            that.src = url
            that.visible = true
            // printJS({printable: url, type: 'image'})
          })
          // that.src=mapCanvas.toDataURL("image/png");
          // that.visible=true
        }
      })
      map.renderSync()
    },
    print () {
      printJS({ printable: this.src, type: 'image', header: '图片' })
    }
  }
}
</script>

<style>
.main_control {
  width: 76px;
  position: absolute;
  z-index: 1;
  right: 3%;
  bottom: 100px;
  overflow: hidden;
}

.ol-tooltip {
  width: 200px;
  height: 40px;
  line-height: 40px;
  color: green;
  text-align: center;
  font-size: 20px;
}
</style>
